<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background-color: #f5f5f5;
}

#app {
  min-height: 100vh;
}

.like-icon {
  background: url(~@/assets/like-icon.svg) no-repeat center;
  background-size: 20px 20px;
  display: inline-block;
  height: 20px;
  width: 20px;
  margin-right: 0;
  vertical-align: middle;
}

.action-btn.liked .like-icon {
  background: url(~@/assets/like-icon-active.svg) no-repeat center;
  background-size: 20px 20px;
}

.like-icon-sm {
  background: url(~@/assets/like-icon.svg) no-repeat center;
  background-size: 20px 20px;
  display: inline-block;
  height: 20px;
  width: 20px;
  vertical-align: middle;
}

.stat-icon, .action-icon {
  font-size: 20px;
}

/* Footer 全局样式 */
.df {
  display: flex;
}

.aic {
  align-items: center;
}

.fw6 {
  font-weight: 600;
}

.cup {
  cursor: pointer;
}

.group-width {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

@media (max-width: 768px) {
  .group-width {
    padding: 0 15px;
  }
}
</style>